import { DemandeDevis } from '@/models/DemandeDevis';

export interface Devis {
    chiffrageId: number;
    numero: number;
    version: number;
    objet: string;
    prix: number;
    monnaie: string;
    numCommande: string;
    montantFacture?: number;
    numFactures?: string[];
    etatDevis: string;
    dateChiffrage: string;
    demandeDevis: DemandeDevis;
    demandeDevisId: number;
}

export enum EtatDevis {
    publie = 'PUBLIE',
    enCours = 'ENCOURS',
    enCommande = 'ENCOMMANDE',
    commandeTransmise = 'COMMANDE_TRANSMISE',
    realise = 'REALISE',
    refuse = 'REFUSE',
    enSignature = 'EN_SIGNATURE',
}
